import { datadogLogs } from '@datadog/browser-logs';

const createLogger = () => {
  const info = (key: string, data = {}) => {
    datadogLogs.logger.info(key, { rlog: data });
  };

  const warn = (key: string, data = {}) => {
    datadogLogs.logger.warn(key, { rlog: data });
  };

  const error = (key: string, data = {}) => {
    datadogLogs.logger.error(key, { rlog: data });
  };

  const debug = (key: string, data = {}) => {
    datadogLogs.logger.debug(key, { rlog: data });
  };

  return { info, warn, error, debug };
};

export default createLogger();
